import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Loading from "../Loading";
        const Div = styled.div`
        max-width: 90%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        background: white;
        padding: 2% 0;
        margin-top: 5rem;
        margin-bottom: 5%;
        border: 1px grey solid;
        @media (min-width: ${props => props.theme.mobileBreakpoint}){
            max-width: 80%;
            /* border: 1px grey solid; */
            border-radius: 1.4%;
        }
        @media (min-width: ${props => props.theme.tabletBreakpoint}){
            /* border: 1px grey solid; */
            border-radius: 1.4%;
            max-width: 30%;
        }
    `
const Div2 = styled.div`
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        width: 40%;
    }
`

const Member = (props) => {

    const [userInfo, setUserInfo] = useState()

    useEffect(()=>{
        setUserInfo(props.userInfo)
    },[props])


    return(
        <>
            {!userInfo ? <Loading/> : 
                <Div>
                    <Grid container direction={"column"} spacing={2}>
                        <Grid item>
                            <h4>{userInfo.fname.toUpperCase()} {userInfo.mname.toUpperCase()} {userInfo.lname.toUpperCase()}</h4>
                        </Grid>
                        <Grid item>
                            <h4>{userInfo.username}</h4>
                        </Grid>
                        <Grid item>
                            <h4>Points: {userInfo.points}</h4>
                        </Grid>
                    </Grid>
                    {/* <Grid container direction={"column"} spacing={8}> */}
                        {/* <Grid item> */}
                            
                        {/* </Grid> */}
                    {/* </Grid> */}
                </Div>
            }
            <Div2>
                <h4>Honor Cord Requirement: You must have 12
                                    points each year to receive an honor upon 
                                    graduation.
                </h4>
            </Div2>
        </>
    )
}

export default Member;